import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'unitsSoldFormat',
  standalone: false
})
export class UnitsSoldFormatPipe implements PipeTransform {

  transform(value: number): string {
    if (!value || value <= 0) {
      return '';
    }

    // If less than a million, show in 'k' format
    if (value < 1000000) {
      // Round down to the nearest ten thousand
      const rounded = Math.floor(value / 10000) * 10000;
      const thousands = rounded / 1000;
      return `${thousands}k`;
    }

    // If one million or more, show with one decimal
    const millions = value / 1000000;
    const roundedMillions = Math.round(millions * 10) / 10; // Round to one decimal
    return `${roundedMillions} million`;
  }

}

